import axios from "axios";

const RAW_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
if (!RAW_BACKEND_URL) {
  // Build-time misconfiguration: this bundle was built without REACT_APP_BACKEND_URL,
  // so API calls would hit "<frontend-host>/undefined/api/..." and return a misleading 404.
  console.error("[AURO OA] REACT_APP_BACKEND_URL was not set when this frontend was built. Falling back to same-origin /api — make sure the web server proxies /api/* to the FastAPI backend.");
}
const API = `${RAW_BACKEND_URL || window.location.origin}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("oa_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("oa_token");
      if (!window.location.pathname.startsWith("/login")) {
        sessionStorage.setItem("oa_session_expired", "1");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fb = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || e?.message || fb;
};

export const inr = (n) =>
  new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 2 }).format(Number(n || 0));

export default api;
